export default "__VITE_ASSET__B_h1HkJs__"